module.exports = __webpack_public_path__ + "static/img/MC.3596ae35.jpg";